const homeLandingEN = {
	hero: {
		title:
			"Automate bookings, grow your business.",
		subtitle:
			"Sin Fila organizes your appointments, gives your business more visibility, and makes booking easy for your customers — all in one place.",
		primaryCta: "Register now for free",
		secondaryCta: "Explore Services",
		platformStrong: "Perfect for - ",
		platformRest: "Barbers • Salons • Spas • Tutors • Many more!",
		freeTrial: "14 day ",
		freeTrialText: "free trial. No commitment.", 
	},

	whatWeDo: {
		title: "Why businesses love Sin Fila",
		description:
			"Sin Fila connects businesses with clients through simple, fast, no-wait digital bookings.",
	},

	business: {
		title: "Key benefits for businesses",
		intro:
			"Organize your schedule, automate appointments, and avoid losing clients.",
		items: [
			"Receive online bookings 24/7",
			"Automatic confirmations and reminders",
			"Clear schedules with no overlaps",
			"Public profile to attract new clients",
			"Less time on WhatsApp — more time working",
		],
		cta: "Go to business area",
	},

	clients: {
		title: "Key benefits for customers",
		intro:
			"Book your appointment in seconds, without calls or waiting.",
		items: [
			"See real availability",
			"Book instantly",
			"Receive automatic reminders",
			"Reschedule or cancel stress-free",
			"Find barbershops, salons, and more near you",
		],
		cta: "Explore businesses",
	},

	about: {
		title: "How it works",
		step1: "Step 1",
		step1Text: "Sign up in 15 minutes — no contracts, no hassle.",
		step2: "Step 2",
		step2Text: "Your schedule, handled automatically.",
		step3: "Step 3",
		step3Text: "Bookings made easy.",
		paragraph1:
			"Create your business profile, list your services, set your hours, and get your calendar ready to receive bookings.",
		paragraph2:
			"Add your staff, assign roles, and manage multiple calendars. Automatic scheduling avoids double bookings and keeps your team organized.",
		paragraph3:
			"Clients can book online instantly. Confirmations, reminders, and notifications keep everyone in the loop.",
	},

	dominican: {
		eyebrow: "Who are we?",
		title: "A Dominican company, built for Dominican businesses.",
		paragraph1:
			"Sin Fila was created with one mission: to help Dominican businesses modernize the way they manage appointments and grow. We are proudly registered in the Dominican Republic and committed to supporting local entrepreneurs with technology designed around the realities of doing business here.",
		paragraph2:
			"Our vision is to become the trusted technology partner for thousands of Dominican businesses—helping them grow, serve more customers, and embrace the future with confidence.",
		linkText: "Learn more about our story",
	},

	finalCta: {
		text: "Start free with a 14-day trial and earn with our referral program. For every successful referral, you both win.",
	},

	testimonials: {
		title: "What our clients are saying",
		items: [
			{
				quote:
					"Sin Fila has made it so much easier to organize my appointments and my day. My clients can book directly, even for at-home services, and I have everything organized in one place.",
				name: "Sara",
				role: "Wellness professional",
				location: "Las Terrenas",
			},
			{
				quote:
					"Sin Fila has helped me keep my schedule much more organized and cut down the time I spend coordinating appointments. It also helps new clients discover me and book with me easily.",
				name: "Pedro",
				role: "Barber",
				location: "Las Terrenas",
			},
			{
				quote:
					"Sin Fila helped me organize my salon much better. Now I can see and manage my whole team's schedules from one place, and it's much easier to coordinate hours and appointments.",
				name: "Maria",
				role: "Salon owner",
				location: "Santo Domingo",
			},
		],
	},

	businessPoints: [
		{
			title: "Never miss a booking",
			desc: "All appointments, confirmations, and reminders in one place.",
		},
		{
			title: "Attract new clients and fill your schedule",
			desc: "Show your business to more clients in our marketplace.",
		},
		{
			title: "Save time managing your shop and staff",
			desc: "Manage your services and staff calendars effortlessly.",
		},
		{
			title: "Effortless bookings for your clients",
			desc: "Clients book, modify, and get reminders automatically.",
		},
	],
};

export default homeLandingEN;